/* eslint-disable import/no-cycle */
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import useQueryData from './use-query-data';
const getLink = (props) => {
    if (props?.to && typeof props.to === "string") {
        return {
            link: props.to,
            children: ""
        };
    }
    if (props?.[0] && props?.[0]?.link) {
        let externalLink = props?.[0]?.link?.[0]?.externalLink;
        let internalLink = props?.[0]?.link?.[0]?.internalLink?.permalink;
        return {
            link: externalLink || internalLink,
            children: props?.[0]?.title || ""
        };
    }
    return {
        link: "",
        children: "Invalid Link"
    };
};
const Link = ({ to, children, onClick, lang, goToRootIfNoMatch, ...props }) => {
    const { link: trueTo, children: altChildren, } = getLink({ to, ...props });
    const [path, queryString, hash] = useQueryData(trueTo);
    const linkRef = React.useRef(null);
    const linkIsExternal = path.includes(':') || path.startsWith('www.');
    if (linkIsExternal) {
        return (React.createElement("a", { ref: linkRef, href: trueTo, rel: "noreferrer noopener", ...props }, children || altChildren));
    }
    return (React.createElement(GatsbyLink
    // eslint-disable-next-line
    // @ts-ignore
    , { 
        // eslint-disable-next-line
        // @ts-ignore
        ref: linkRef, to: `${path}${queryString}`, onClick: (e) => {
            if (hash) {
                // eslint-disable-next-line
                // @ts-ignore
                window.gatsby_router_hash = hash;
            }
            if (onClick) {
                onClick(e);
            }
        }, ...props }, children || altChildren));
};
export default Link;
//# sourceMappingURL=index.js.map